import React, { useState } from "react";
import { NavLink, Link } from "react-router-dom";

import LogoLight from "../assets/images/property/pmgluxury/pmg_lux_logo.png";
import LogoDark from "../assets/images/property/pmgluxury/pmg_lux_logo.png";

export default function Navbar(props) {
  const { navClass, topnavClass, tagLine } = props;

  let [toggle, setToggle] = useState(false);
  let [manu] = useState("");
  let [scroll] = useState(true);

  return (
    <React.Fragment>
      <a
        href="#main-content"
        className="sr-only focus:not-sr-only focus:absolute focus:top-2 focus:left-2 focus:z-50 focus:px-4 focus:py-2 focus:bg-white focus:text-slate-900 focus:rounded-md focus:shadow-lg"
      >
        Skip to main content
      </a>
      <nav
        id="topnav"
        className={`defaultscroll is-sticky ${scroll ? "nav-sticky" : ""} ${
          tagLine ? "tagline-height" : ""
        } ${topnavClass ? topnavClass : ""} 
            `}
      >
        <div
          className={`${
            topnavClass !== "" && topnavClass !== undefined
              ? "container-fluid md:px-8 px-3"
              : "container"
          }`}
        >
          {/* <!-- Logo container --> */}
          <Link className="logo" to="/">
            <span className="inline-block dark:hidden">
              <img
                src={LogoDark}
                alt="PMG Luxury Rentals"
                className="h-10 md:h-24 w-auto object-contain"
                loading="eager"
                width="240"
                height="96"
              />
            </span>
            <span className="hidden dark:inline-block">
              <img
                src={LogoLight}
                alt="PMG Luxury Rentals"
                className="h-10 md:h-24 w-auto object-contain"
                loading="eager"
                width="240"
                height="96"
              />
            </span>
          </Link>
          {/* <!-- End Logo container --> */}

          {/* <!-- Start Mobile Toggle --> */}
          <div className="menu-extras">
            <div className="menu-item">
              <button
                type="button"
                className={`${toggle ? "open" : ""} navbar-toggle`}
                id="isToggle"
                onClick={() => setToggle(!toggle)}
                aria-expanded={toggle}
                aria-controls="navigation"
                aria-label="Toggle navigation menu"
              >
                <div className="lines">
                  <span></span>
                  <span></span>
                  <span></span>
                </div>
              </button>
            </div>
          </div>

          <div id="navigation" style={{ display: toggle ? "block" : "none" }}>
            {/* <!-- Navigation Menu--> */}
            <ul
              className={`navigation-menu  ${
                navClass === "" || navClass === undefined ? "" : "nav-light"
              }   ${
                topnavClass !== "" && topnavClass !== undefined
                  ? "justify-center"
                  : "justify-end"
              }`}
            >
              <li className={manu === "/sell" ? "active" : ""}>
                <NavLink
                  to="/list"
                  className={({ isActive }) => `sub-menu-item font-display tracking-[0.2em] uppercase text-sm ${isActive ? "active text-gold-600" : ""}`}
                >
                  Properties
                </NavLink>
              </li>

              <li className={manu === "/aboutus" ? "active" : ""}>
                <Link to="/aboutus" className="sub-menu-item font-display tracking-[0.2em] uppercase text-sm">
                  About PMG
                </Link>
              </li>

              <li className={manu === "/contact" ? "active" : ""}>
                <Link to="/contact" className="sub-menu-item font-display tracking-[0.2em] uppercase text-sm">
                  Contact
                </Link>
              </li>

            </ul>
          </div>
        </div>
      </nav>
      {/* End Navbar  */}
    </React.Fragment>
  );
}
